import { Component, OnInit } from '@angular/core';
import { environment } from './../environments/environment';
import { AuthServiceService } from './services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})

export class AppComponent implements OnInit {
  title = 'Thumper Games Angular App';
  constructor(private authService: AuthServiceService) {
    console.log(environment);
    this.authService.initialize();
  }

  ngOnInit(): void { }
}
